export const appAdminSettingRoutes: any[] = [
    {
        path: "/admin/settings/usermanagement",
        section: "usermanagement",
        sidebarProps: {
            displayText: "User management",
            icon: 'manage_accounts',
        },
        child: [
            {
                path: "/admin/settings/users",
                section: "settingsusers",
                sidebarProps: {
                    displayText: "Users",
                },
            },
            {
                path: "/admin/settings/user-roles",
                section: "settingsuserroles",
                sidebarProps: {
                    displayText: "User Roles",
                },
            },
            {
                path: "/admin/settings/access-control",
                section: "settingsaccesscontrol",
                sidebarProps: {
                    displayText: "Access Control",
                },
            },
        ],
    },
    {
        path: "/admin/settings/carrental",
        section: "carrental",
        sidebarProps: {
            displayText: "Charter",
            icon: "directions_car",
        },
        child: [
            {
                path: "/admin/settings/rates",
                section: "settingsrates",
                sidebarProps: {
                    displayText: "Rate Units",
                },
            },
            {
                path: "/admin/settings/seasons",
                section: "settingsseasons",
                sidebarProps: {
                    displayText: "Seasons",
                },
            },
            {
                path: "/admin/settings/fuel-surcharge-rules",
                section: "settingsfuelsurchargerules",
                sidebarProps: {
                    displayText: "Fuel Surcharge Rules",
                },
            },
            {
                path: "/admin/settings/gratuity-rules",
                section: "settingsgratuityrules",
                sidebarProps: {
                    displayText: "Gratuity Rules",
                },
            },
            {
                path: "/admin/settings/vehicle-rates",
                section: "settingsvehiclerates",
                sidebarProps: {
                    displayText: "Vehicle Rates",
                },
            },
        ],
    },
    {
        path: "/admin/settings/fleet",
        section: "fleet",
        sidebarProps: {
            displayText: "Fleet",
            icon: "local_shipping",
        },
        child: [
            {
                path: "/admin/settings/operator-types",
                section: "settingsaccesscontrol",
                sidebarProps: {
                    displayText: "Operator Types",
                },
            },
            {
                path: "/admin/settings/drivers",
                section: "settingsdriver",
                sidebarProps: {
                    displayText: "Drivers",
                },
            },
            {
                path: "/admin/settings/group-types",
                section: "settingsgrouptypes",
                sidebarProps: {
                    displayText: "Group Types",
                },
            },
            {
                path: "/admin/settings/autonomous-operators",
                section: "settingsautonomousoperators",
                sidebarProps: {
                    displayText: "Autonomous Operators",
                },
            },
        ],
    },
];